module.exports = __webpack_public_path__ + "img/default_pic.9acfe78b.png";